import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const UpdateNotificationContext = createContext(null);

type Props = {
  children: ReactElement;
};

const UpdateNotificationProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.put("settings/notification", payload);
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <UpdateNotificationContext.Provider value={contextValue}>
      {children}
    </UpdateNotificationContext.Provider>
  );
};

export default UpdateNotificationProvider;
